<template>
  <div class="plugin-main-content">
    <div class="title">{{ $t(`admin.application.extension.title`) }}</div>
    <div class="content">{{ $t(`admin.application.extension.content`) }}</div>
    <div class="options">
      <div class="option">
        <div class="content">
          <div>{{ $t(`admin.application.extension.optionFirst`) }}</div>
          <div>
            {{ $t(`admin.application.extension.downloadHead`) }}
            <a :href="googleStoreLink" target="_blank" class="link">{{ $t(`admin.application.extension.chromeStore`) }}</a>
            {{ $t(`admin.application.extension.downloadTail`) }}
          </div>
        </div>
        <div class="recommend" >
          <img class="image" src="~@/assets/image/extension/recommend.png" alt="">
        </div>
        <div class="chrome-plugin" @click="toGoogleStore">
          <img class="image" src="~@/assets/image/extension/chrome_plugin.png" alt="">
        </div>
      </div>
      <div class="connector">{{ $t(`admin.application.extension.or`) }}</div>
      <div class="option">
        <div class="content">
          <div>{{ $t(`admin.application.extension.optionSecond`) }}</div>
          <div>
            {{ $t(`admin.application.extension.downloadFromPackage`) }}
          </div>
        </div>
        <div class="button-group">
          <div :class="buttonMacClass" @click="downloadPlugin">
            <div class="font">{{ $t(`admin.application.extension.downloadForMac`) }}</div>
          </div>
          <div :class="buttonWindowsClass" @click="downloadPlugin">
            <div class="font">{{ $t(`admin.application.extension.downloadForWindows`) }}</div>
          </div>
        </div>
        <div :class="macIconClass" @click="selectMac">
          <img class="image" :src="macIconImage" alt="">
        </div>
        <div :class="windowIconClass" @click="selectWindows">
          <img class="image" :src="windowsIconImage" alt="">
        </div>
      </div>
    </div>
    <div class="divide-line"></div>
    <div class="plugin-process">
      <img class="image" :src="pluginImage" alt="">
    </div>
  </div>
</template>

<script>
import { isEn } from '@/i18n'

export default {
  data () {
    return {
      macSelected: true,
      macIconClass: 'mac-icon-selected',
      windowIconClass: 'windows-icon',
      buttonMacClass: 'button-mac-selected',
      buttonWindowsClass: 'button-windows'
    }
  },
  computed: {
    pluginMacImage () {
      return isEn() ? this.getPluginImage('plugin_mac_en') : this.getPluginImage('plugin_mac_cn')
    },
    pluginWindowsImage () {
      return isEn() ? this.getPluginImage('plugin_windows_en') : this.getPluginImage('plugin_windows_cn')
    },
    pluginImage () {
      return this.macSelected ? this.pluginMacImage : this.pluginWindowsImage
    },
    macIconImage () {
      return this.macSelected ? this.getPluginImage('select_mac_icon') : this.getPluginImage('mac_icon')
    },
    windowsIconImage () {
      return this.macSelected ? this.getPluginImage('windows_icon') : this.getPluginImage('select_windows_icon')
    },
    googleStoreLink () {
      if (isEn()) {
        return 'https://chrome.google.com/webstore/detail/ajinga%20/cebogjepmogfhnhimhkolpmicefbompl?hl=en'
      }
      return 'https://chrome.google.com/webstore/detail/ajinga%20/cebogjepmogfhnhimhkolpmicefbompl?hl=zh-CN'
    }
  },
  methods: {
    getPluginImage (type) {
      return require(`@/assets/image/extension/${type}.png`)
    },
    selectMac () {
      this.macSelected = true

      this.macIconClass = 'mac-icon-selected'
      this.windowIconClass = 'windows-icon'
      this.buttonMacClass = 'button-mac-selected'
      this.buttonWindowsClass = 'button-windows'
    },
    selectWindows () {
      this.macSelected = false
      this.macIconClass = 'mac-icon'
      this.windowIconClass = 'windows-icon-selected'
      this.buttonMacClass = 'button-mac'
      this.buttonWindowsClass = 'button-windows-selected'
    },
    toGoogleStore () {
      window.open(this.googleStoreLink)
    },
    downloadPlugin () {
      window.location.href = 'https://cdn.ajinga.com/Widget/ajinga_widget_1.2.8.zip'
    }
  }
}
</script>

<style lang="scss" scoped>
.plugin-main-content {
  margin-left: 63px;
  margin-top: 18px;
  margin-right: 63px;
  min-width: 1150px;

  .title {
    font-size: 22px;
    line-height: 30px;
    height: 30px;
    font-weight: bold;
    color: #303133;
  }

  .content {
    font-size: 16px;
    color: #606266;
    line-height: 22px;
    margin-top: 14px;
  }

  .options {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;

    & .option:first-child {
      margin-left: 58px;
    }

    & .option:last-child {
      margin-right: 58px;
    }

    .option {
      width: 41%;
      height: 295px;
      background: #FFFFFF;
      border-radius: 6px;
      position: relative;
      box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.08);

      .content {
        margin: 51px 63px 0 60px;
        font-size: 18px;
        color: #303133;
        line-height: 25px;
      }

      .recommend {
        position: absolute;
        right: 0;
        top: 0;
        width: 111px;
      }

      .chrome-plugin {
        position: absolute;
        top: 65%;
        left: 50%;
        width: 114px;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }

      .mac-icon-selected {
        position: absolute;
        top: 42%;
        left: 20%;
        width: 71px;
        cursor: pointer;
      }

      .mac-icon {
        position: absolute;
        top: 42%;
        left: 20%;
        width: 71px;
        cursor: pointer;
      }

      .windows-icon-selected {
        position: absolute;
        top: 42%;
        right: 20%;
        width: 71px;
        cursor: pointer;
      }

      .windows-icon {
        position: absolute;
        top: 42%;
        right: 20%;
        width: 71px;
        cursor: pointer;
      }

      .button-group {
        .button-mac-selected {
          position: absolute;
          bottom: 15%;
          left: 7%;
          width: 40%;
          height: 32px;
          background: #FFFFFF;
          border-radius: 6px;
          border: 1px solid #0096CC;
          text-align: center;
          cursor: pointer;

          .font {
            font-size: 14px;
            color: #0096CC;
            position: absolute;
            width: 90%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .button-mac {
          position: absolute;
          bottom: 15%;
          left: 7%;
          width: 40%;
          height: 32px;
          background: #FFFFFF;
          border-radius: 6px;
          border: 1px solid #C0C4CC;
          text-align: center;
          cursor: pointer;

          .font {
            font-size: 14px;
            color: #606266;
            position: absolute;
            width: 90%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .button-windows {
          position: absolute;
          bottom: 15%;
          right: 7%;
          width: 40%;
          height: 32px;
          background: #FFFFFF;
          border-radius: 6px;
          border: 1px solid #C0C4CC;
          text-align: center;
          cursor: pointer;

          .font {
            font-size: 14px;
            color: #606266;
            position: absolute;
            width: 90%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .button-windows-selected {
          position: absolute;
          bottom: 15%;
          right: 7%;
          width: 40%;
          height: 32px;
          background: #FFFFFF;
          border-radius: 6px;
          border: 1px solid #0096CC;
          text-align: center;
          cursor: pointer;

          .font {
            font-size: 14px;
            color: #0096CC;
            position: absolute;
            width: 90%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }

    .connector {
      font-size: 28px;
      color: #606266;
      display: flex;
      margin: 0 51px;
      width: 41px;
      margin-top: 145px;
      height: 40px;
      line-height: 40px;
    }
  }
}

.divide-line {
  border: 1px solid #DCDFE6;
  margin-top: 80px;
}

.plugin-process {
  width: 85%;
  margin: auto;
}

.image {
  width: 100%;
}
</style>
